import React from "react";

const TabPanel = (props) => {
  const { children, value, index, role, ...more } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${role}-${index}`}
      aria-labelledby={`tabpanel-${role}-${index}`}
      {...more}
    >
      {value === index && children }
    </div>
  );
};
export default TabPanel;
